export default {
    // 绘制折线
    drawPolyline(ctx, points, width, color) {
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.beginPath();
        ctx.moveTo(points[0][0], points[0][1]);
        for (let i = 1;  i < points.length; i++) {
            ctx.lineTo(points[i][0], points[i][1]);
        }
        ctx.stroke();
    },
    // 绘制一个多边形
    drawPolygon(ctx, points, lineColor, fillColor) {
        ctx.strokeStyle = lineColor;
        ctx.beginPath(); // 开始一个新的路径
        ctx.moveTo(points[0][0], points[0][1]); // 移动到多边形的第一个点
        for (let i = 1; i < points.length; i++) {
            ctx.lineTo(points[i][0], points[i][1]); // 从当前点绘制到下一个点
        }
        ctx.closePath(); // 闭合路径，即回到第一个点
        ctx.lineWidth = 1;
        ctx.stroke(); // 描边多边形（可选）
        ctx.fillStyle = fillColor;
        ctx.fill(); // 填充多边形（可选）
    },
    // 绘制一个多边形,多边形的边角带弧形
    drawCircle(ctx, point, radius, color) {
        ctx.fillStyle = color;
        ctx.beginPath(); // 开始一个新的路径
        ctx.arc(point[0], point[1], radius, 0, Math.PI * 2)
        ctx.fill(); // 填充多边形（可选）
    }
}